import { useEffect, useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { failedMessage } from "utils/httpClient";
import { successMessage } from "utils/httpClient";
import { setDefaultHeader } from "utils/httpClient";
import { saveToLocalStorage } from "utils/LocalStorageUtils";
import { Spinner } from "react-bootstrap";

const GoolgeLoginModal = ({ }) => {

	const [user, setUser] = useState([]);
	const [profile, setProfile] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const signupWithGoogle = useGoogleLogin({
		onSuccess: (codeResponse) => setUser(codeResponse),
		onError: (error) => console.log('Login Failed:', error)
	});

	useEffect(() => {
		signupWithGoogle()
	}, [])
	useEffect(() => {
		if (user) {
			setIsLoading(true)
			axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
				headers: {
					Authorization: `Bearer ${user.access_token}`,
					Accept: 'application/json'
				}
			}).then(async (res) => {
				let params = res.data
				params['google_id'] = params?.id
				params['user_name'] = params?.name
				params['profile_image'] = params?.picture
				setProfile(params);
				const { data } = await apiCall("post", apiEndPoint.GOOGLESIGNIN, params);
				if (data.status !== 200) {
					failedMessage(data.message);
				}
				if (data.status === 200) {
					successMessage(data.message);
					setDefaultHeader("token", data.data.token);
					saveToLocalStorage("AUTH_DATA", data.data);
					navigate("/");
				}
			}).catch((err) => console.log(err));
			setIsLoading(false)
		}
	}, [user]);
	return (
		<div className="App">
			{isLoading &&
				<center style={{ paddingTop: '15%' }}>
					<Spinner animation="border" role="status" />
				</center>
			}
		</div>
	);
};

export default GoolgeLoginModal;